import { useEffect, useRef } from 'react';
import { broadcastBasicSearch } from '../services/angular-bridge';

/**
 * Runs a basic search once the page is ready — e.g. `?q=` or a resource id from an SSO
 * deep link. `ready` must wait until the page has set Angular's current project/collection,
 * since the search scope is read from there. Each distinct query runs once.
 */
export function useInitialSearch(query: string | undefined, context: 0 | 1, ready: boolean): void {
  const ran = useRef<string | null>(null);
  useEffect(() => {
    if (!ready || !query || ran.current === query) return;
    ran.current = query;
    broadcastBasicSearch(query, context);
  }, [ready, query, context]);
}
